import { createPatch } from 'rfc6902';
export function getSubdomainUrl(url) {
    var _a;
    if (!url || !((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host)) {
        return '';
    }
    if (url.indexOf('{subdomain}') > -1) {
        return url.replace('{subdomain}', window.location.host.split('.')[0]);
    }
    return url;
}
export const getPatchRequestBody = (body, previousValue) => {
    return typeof body === 'object' ? createPatch(previousValue || {}, body) : body;
};
export const getFetchRequestInit = (params) => {
    // Prepare params
    const authorization = params.authToken ? `Bearer ${params.authToken}` : '';
    const body = params.request.httpMethod === 'PATCH'
        ? getPatchRequestBody(params.request.body, params.request.previousValue)
        : params.request.body;
    // Make request
    if (params.request.form) {
        return {
            method: params.request.httpMethod,
            body,
            headers: params.authToken ? new Headers({ Authorization: authorization }) : undefined,
        };
    }
    else if (params.request.httpMethod === 'GET') {
        return {
            method: 'GET',
            headers: params.authToken
                ? new Headers({
                    Authorization: authorization,
                    'Content-Type': 'application/json',
                })
                : new Headers({ 'Content-Type': 'application/json' }),
        };
    }
    return {
        method: params.request.httpMethod,
        body: JSON.stringify(body),
        headers: params.authToken
            ? new Headers({
                Authorization: authorization,
                'Content-Type': 'application/json',
            })
            : new Headers({ 'Content-Type': 'application/json' }),
    };
};
export function makeApiCall(params) {
    // Prepare params
    const url = getSubdomainUrl(params.request.url);
    return fetch(url, getFetchRequestInit(params));
}
//# sourceMappingURL=index.js.map